enum FlyerType {
  New,
  Example,
  CopyrightedExample,
  Own,
  Template
}

export default FlyerType;



// WEBPACK FOOTER //
// ./src/data/FlyerType.ts